import React, { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import {
  requestLocationChange,
  fetchFilterOptions,
  fetchPolicies,
  saveNewInfluencer,
 } from '../actions';
import debounce from 'lodash/debounce';

import LoadingOverlay from '../components/LoadingOverlay';
import css from '../components/forms/forms.css';

import ParentAccountSearch from '../components/forms/ParentAccountSearch';
import Addresses from '../components/forms/Addresses';
import MultipleSelect from '../components/forms/MultipleSelect';
import SocialMedia from '../components/forms/SocialMedia';
import Policies from '../components/forms/Policies';
import Awards from '../components/forms/Awards';
import MultiText from '../components/forms/MultiText';

// Material UI Library
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import AutoComplete from 'material-ui/AutoComplete';
import Dialog from 'material-ui/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class NewInfluencer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openWarningDialog: false,
      formAttributes: Immutable.Map({
        firstName: '',
        lastName: '',
        alias: '',
        collectiveId: null,
        gender: '',
        birthdate: '',
        phone: '',
        mobile: '',
        fax: '',
        notes: '',
        games: '',
        emailsAttributes: Immutable.List(),
        addressesAttributes: Immutable.List(),
        influencerGameGenresAttributes: Immutable.List(),
        influencerGamePlatformsAttributes: Immutable.List(),
        influencerSocialMediaAttributes: Immutable.List(),
        influencerPoliciesAttributes: Immutable.List(),
        awardsAttributes: Immutable.List(),
      }),
    };
  }

  handleForm = (e) => {
    e.preventDefault();

    const newInfluencer =
      {
        influencer: {
          firstName: this.state.formAttributes.get('firstName'),
          lastName: this.state.formAttributes.get('lastName'),
          phone: this.state.formAttributes.get('phone'),
          fax: this.state.formAttributes.get('fax'),
          mobile: this.state.formAttributes.get('mobile'),
          alias: this.state.formAttributes.get('alias'),
          notes: this.state.formAttributes.get('notes'),
          collectiveId: this.state.formAttributes.get('collectiveId'),
          gender: this.state.formAttributes.get('gender'),
          birthdate: this.state.formAttributes.get('birthdate'),
          games: this.state.formAttributes.get('games'),
          emailsAttributes: this.state.formAttributes.get('emailsAttributes').toJS(),
          addressesAttributes: this.state.formAttributes.get('addressesAttributes').toJS(),
          influencerGameGenresAttributes: this.state.formAttributes.get('influencerGameGenresAttributes').toJS(),
          influencerGamePlatformsAttributes: this.state.formAttributes.get('influencerGamePlatformsAttributes').toJS(),
          influencerSocialMediaAttributes: this.state.formAttributes.get('influencerSocialMediaAttributes').toJS(),
          influencerPoliciesAttributes: this.state.formAttributes.get('influencerPoliciesAttributes').toJS(),
          awardsAttributes: this.state.formAttributes.get('awardsAttributes').toJS(),
        },
      };

    this.props.dispatch(saveNewInfluencer(newInfluencer));
    this.setState({ saving: true });
  };


  componentDidMount() {
    if (!this.props.isFetching && this.props.socialMedia.get('result').size === 0) {
      this.props.dispatch(fetchFilterOptions());
    }

    this.props.dispatch(fetchPolicies());
  }

  componentWillReceiveProps(newProps) {
    // if saving and returns a new collective
    if (
      !newProps.isFetching &&
      this.props.influencers.get('result') !== newProps.influencers.get('result')
    ) {
      this.props.dispatch(requestLocationChange('viewInfluencer', { id: newProps.influencers.get('result') }));
    }
  }

  handleTextChange = (property, e, value) => {
    this.handleFormUpdate(property, value);
  };

  handleSelectMenu = (property, e, i, value) => {
    this.handleFormUpdate(property, value);
  };

  handleUpdateGamingPlatforms = (ids) => {
    this.handleFormUpdate('influencerGamePlatformsAttributes', ids.map(id => ({ game_platform_id: id })));
  };

  handleUpdateGamingGenres = (ids) => {
    this.handleFormUpdate('influencerGameGenresAttributes', ids.map(id => ({ game_genre_id: id })));
  };

  handleUpdateGames = (ids) => {
    this.handleFormUpdate('influencerGameGenresAttributes', ids.map(id => ({ game_genre_id: id })));
  };

  handleFormUpdate = (property, value) => {
    // console.log('previous state', this.state.formAttributes.toJS());
    this.setState({ formAttributes: this.state.formAttributes.set(property, value) });
  };

  handleCloseWarning = () => {
    this.setState({ openWarningDialog: false });
  };

  handleExitForm = () => {
    this.props.dispatch(requestLocationChange('home'));
  };

  handleCancelForm = (e) => {
    e.preventDefault();

    this.setState({ openWarningDialog: true });
  };


  render() {
    return (
      <form onSubmit={this.handleForm} className={css.root} style={{ position: 'relative' }}>
        <section>
          <TextField
            floatingLabelText="First Name"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'firstName'), 300)}
          />
          <TextField
            floatingLabelText="Last Name"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'lastName'), 300)}
          />
        </section>
        <section>
          <ParentAccountSearch
            className={css.textField}
            fullWidth={true}
            updateForm={this.handleFormUpdate.bind(this, 'collectiveId')}
          />
        </section>
        <h3 className={css.title}>Email Addresses</h3>
        <MultiText
          name="email"
          fullWidth={true}
          floatingLabelText="Email"
          updateForm={this.handleFormUpdate.bind(this, 'emailsAttributes')}
        />
        <section>
          <TextField
            floatingLabelText="Phone"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'phone'), 300)}
          />
          <TextField
            floatingLabelText="Mobile Phone"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'mobile'), 300)}
          />
          <TextField
            floatingLabelText="Fax"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'fax'), 300)}
          />
        </section>
        <section>
          <TextField
            floatingLabelText="Alias"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'alias'), 300)}
          />
          <SelectField
            hintText="Gender"
            value={this.state.formAttributes.get('gender')}
            onChange={this.handleSelectMenu.bind(this, 'gender')}
            style={{ margin: '0 10px' }}
          >
            <MenuItem value={'female'} primaryText="Female" />
            <MenuItem value={'male'} primaryText="Male" />
            <MenuItem value={'other'} primaryText="Other" />
          </SelectField>
          <TextField
            floatingLabelText="Birthdate"
            hintText="MM/DD/YYYY"
            className={css.textField}
            fullWidth={true}
            onChange={debounce(this.handleTextChange.bind(this, 'birthdate'), 300)}
          />
        </section>
        <section>
          <TextField
            floatingLabelText="Notes"
            className={css.textField}
            fullWidth={true}
            multiLine={true}
            onChange={debounce(this.handleTextChange.bind(this, 'notes'), 300)}
          />
        </section>
        <Addresses
          fullWidth={true}
          updateForm={this.handleFormUpdate.bind(this, 'addressesAttributes')}
        />
        <h3 className={css.title}>Social Media</h3>
        <SocialMedia
          updateForm={this.handleFormUpdate.bind(this, 'influencerSocialMediaAttributes')}
        />
        <h3 className={css.title} key="gaming-platform-title">Gaming Platforms</h3>
        <MultipleSelect
          items={this.props.gamePlatforms.get('entities')}
          result={this.props.gamePlatforms.get('result')}
          hintText="Select Platforms"
          onChange={this.handleUpdateGamingPlatforms}
        />
        <h3 className={css.title}>Primary Games</h3>
        <section>
          <TextField
            floatingLabelText="List Games"
            hintText="Game 1, Game 2, Game 3"
            className={css.textField}
            fullWidth={true}
            multiLine={true}
            onChange={debounce(this.handleTextChange.bind(this, 'games'), 300)}
          />
        </section>
        <h3 className={css.title}>Genres</h3>
        <MultipleSelect
          items={this.props.gameGenres.get('entities')}
          result={this.props.gameGenres.get('result')}
          hintText="Select Genres"
          onChange={this.handleUpdateGamingGenres}
        />
        <h3 className={css.title}>Policies</h3>
        <Policies updateForm={this.handleFormUpdate.bind(this, 'influencerPoliciesAttributes')} />
        <h3 className={css.title}>Awards</h3>
        <Awards
          updateForm={this.handleFormUpdate.bind(this, 'awardsAttributes')}
        />
        <div className={css.actionFooter}>
          <RaisedButton
            secondary={true}
            type="button"
            label="Cancel"
            onClick={this.handleCancelForm}
            style={{ marginRight: '15px' }}
            disabled={this.state.saving}
          />
          <RaisedButton
            primary={true}
            type="submit"
            label="Save"
            disabled={this.state.saving}
          />
        </div>
        <Dialog
          key="cancel-form-dialog"
          title="Leave Page?"
          actions={[<FlatButton
              label="Cancel"
              secondary={true}
              onTouchTap={this.handleCloseWarning}
            />,
            <FlatButton
              label="Continue"
              primary={true}
              onTouchTap={this.handleExitForm}
            />,
          ]}
          modal={true}
          open={this.state.openWarningDialog}
        >
          You will lose all changes if you continue.
        </Dialog>
        <LoadingOverlay loading={this.props.isFetching} />
      </form>
    );
  }

}

function mapStateToProps(state) {
  return {
    socialMedia: state.get('filterOptions').get('socialMedia'),
    gamePlatforms: state.get('filterOptions').get('gamePlatforms'),
    gameGenres: state.get('filterOptions').get('gameGenres'),
    influencers: state.get('influencers'),
    isFetching: state.get('influencers').get('isFetching') || state.get('filterOptions').get('isFetching'),
  };
}

export default connect(mapStateToProps)(NewInfluencer);



/** WEBPACK FOOTER **
 ** ./containers/NewInfluencer.js
 **/